/**
 * @fileoverview POST handler for the "/api/calculated_filters/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postApiCalculatedFiltersAppGroupIdCacheKeys } from "./constants";
import type {
  PostApiCalculatedFiltersAppGroupIdProps,
  PostApiCalculatedFiltersAppGroupIdResult,
  PostApiCalculatedFiltersAppGroupIdResultErrors,
} from "./types";

export const postApiCalculatedFiltersAppGroupId = reactQueryMutationAdapter(
  postApiCalculatedFiltersAppGroupIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostApiCalculatedFiltersAppGroupIdResultErrors>()(
    (props: PostApiCalculatedFiltersAppGroupIdProps): Promise<PostApiCalculatedFiltersAppGroupIdResult> => {
      const { appGroupId, ...calculatedFilterProps } = props;
      return fetch(
        `/api/calculated_filters/${appGroupId}`,
        "POST",
        {
          calculated_filter: calculatedFilterProps,
        },
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
